import React from 'react';
import PostForm from '../components/post/PostForm';

const CreatePostPage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <PostForm mode="create" />
    </div>
  );
};

export default CreatePostPage;